$(function () {
  $('.postcode-live-search').select2({
    placeholder: 'Enter a postcode',
    minimumInputLength: 3,
    dropdownCssClass: 'postcode-dropdown',
    width: '100%',
    ajax: {
      url: '/locations/postcode_live_search',
      data: function (params) {
        return { request_term: params.term }
      },
      dataType: 'json',
      processResults: function (response) {
        var results = $.map(response.data, function (location, _) {
          return {
            id: location.id,
            text: location.suburb + ', ' + location.state + ', ' + location.postcode,
            suburb: location.suburb,
            state: location.state,
            postcode: location.postcode,
          }
        })

        return { results: results }
      },
      cache: true,
    },
  })
})
